// https://joshua1988.github.io/web-development/vuejs/vuex-start/ vuex는 왼쪽 url 참조
// 각각 컴포넌트 (dispatch)--> actions (commit)--> mutations (state)--> state -->모든 컴포넌트에서 활용

import axios from 'axios'
import router from '../../router'

const state = {
  EtcCode001List: [],
  EtcCode002List: [],
  EtcCodeList: [],
  ItemInfoList: [],
  AttachedFile: [],
  deleteFilesRtn: '',
  AttachedFlag: '',
  bannerMainList: [],
  bannerFootList: [],
  windowWidth: window.innerWidth,
  OrderInfo: [],
  totalArea: [],
  // urlpath: 'http://127.0.0.1:8081' // 개발
  urlpath: 'https://ttbb.co.kr' // 실서버
}

const getters = {
  getEtcCodeList (state) {
    return state.EtcCodeList
  },
  getEtcCode001List (state) {
    return state.EtcCode001List
  },
  getEtcCode002List (state) {
    return state.EtcCode002List
  },
  getAttachedFile (state) {
    return state.AttachedFile
  },
  getItemInfoList (state) {
    return state.ItemInfoList
  },
  getDeleteFiles (state) {
    return state.deleteFilesRtn
  },
  getAttachedFlag (state) {
    return state.AttachedFlag
  },
  getBannerMainList (state) {
    return state.bannerMainList
  },
  getBannerFootList (state) {
    return state.bannerFootList
  },
  getOrderInfo (state) {
    return state.OrderInfo
  },
  getTotalArea (state) {
    return state.totalArea
  }
}

const mutations = {
  setEtcCodelists (state, payload) {
    state.EtcCodeList = payload
  },
  setEtcCode001lists (state, payload) {
    state.EtcCode001List = payload
  },
  setEtcCode002lists (state, payload) {
    state.EtcCode002List = payload
  },
  setAttachedFile (state, payload) {
    state.AttachedFile = payload
  },
  setItemInfoList (state, payload) {
    state.ItemInfoList = payload
  },
  setDeleteFiles (state, payload) {
    state.deleteFilesRtn = payload
  },
  setAttachedFlag (state, payload) {
    state.AttachedFlag = payload
  },
  setBannerMainList (state, payload) {
    state.bannerMainList = payload
  },
  setBannerFootList (state, payload) {
    state.bannerFootList = payload
  },
  setOrderInfo (state, payload) {
    state.OrderInfo = payload
  },
  setTotalArea (state, payload) {
    state.totalArea = payload
  }
}

const actions = {
  apiEtcCodelists (context, payload) {
    axios.post('/api/common/EtcCodelists', payload)
      .then((response) => {
        // console.log(response.data)
        if (payload.Code === '001' || payload.Code === '006') {
          context.commit('setEtcCode001lists', response.data)
        } else if (payload.Code === '002' || payload.Code === '007') {
          context.commit('setEtcCode002lists', response.data)
        } else {
          context.commit('setEtcCodelists', response.data)
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiItemInfoists (context, payload) {
    axios.post('/api/common/getItemCodeList', payload)
      .then((response) => {
        // console.log(response.data)
        context.commit('setItemInfoList', response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiOkcertlists (context, payload) {
    axios.post('/api/phone_popup2', payload)
      .then((response) => {
        // console.log(response.data)
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiAttachedFiles (context, payload) {
    // if (sessionStorage.getItem('token') != null) {
    //   axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
    if (payload.flag === 'INSERT') {
      return new Promise((resolve, reject) => {
        axios.post('/api/file/insertAttachedFile', payload)
          .then((response) => {
            // console.log(response.data)
            context.commit('setAttachedFlag', 'ok')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data.message)
            context.commit('setAttachedFlag', 'fail')
            alert(error.response.data.message)
          })
      })
    } else if (payload.flag === 'SELECT') {
      return new Promise((resolve, reject) => {
        axios.post('/api/common/getAttachedFile', payload)
          .then((response) => {
            // console.log(response)
            for (var i = 0; i < response.data.length; i++) {
              response.data[i].path = encodeURI(response.data[i].path)
            }
            context.commit('setAttachedFile', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response.data.message)
            alert(error.response.data.message)
          })
      })
    } else if (payload.flag === 'UPDATE') {
      return new Promise((resolve, reject) => {
        // console.log('무야호 22')
        axios.post('/api/fileUpdate/process', payload)
          .then((response) => {
            // console.log(response.data)
            resolve()
          })
          .catch((error) => {
            alert(error.response.data.message)
          })
      })
    }
    // } else {
    //   alert('세션 만료 또는 잘못된 접근 입니다.')
    //   router.push('/')
    // }
  },
  apiDeleteFiles (context, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/fileDelete/process', payload)
        .then((response) => {
          // console.log('fileDelete = ' + response.data.result)
          context.commit('setDeleteFiles', response.data.result)
          resolve()
        })
        .catch((error) => {
          reject(error.response.data.message)
          alert(error.response.data.message)
        })
    })
  },
  apiDownFiles (context, payload) {
    axios({
      method: 'post',
      url: '/api/fileDownload/process',
      responseType: 'blob',
      data: {
        gubun: payload.gubun,
        idDownFile: payload.idDownFile,
        fileName: payload.fileName
      }
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', payload.fileName)
        document.body.appendChild(link)
        link.click()
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  },
  apiBannerViewList (context, payload) {
    axios.post('/api/common/getBannerInfo', payload)
      .then((response) => {
        // console.log(response.data)
        if (payload.bannerType === '001') {
          context.commit('setBannerMainList', response.data)
        } else {
          context.commit('setBannerFootList', response.data)
        }
      })
      .catch((error) => {
        console.log(error.response.data.message)
      })
  },
  apiGetOrderInfo (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/member/payment/getOrderInfo', payload)
          .then((response) => {
            // console.log(response.data)
            context.commit('setOrderInfo', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            alert(error.response.data.message)
          })
      })
    } else {
      alert('세션 만료 또는 잘못된 접근 입니다.')
      router.push('/')
    }
  },
  apiTotalArea (context, payload) {
    axios.post('/api/common/getProRegion', payload)
      .then((response) => {
        // console.log(response.data)
        context.commit('setTotalArea', response.data)
        if (response.data.length > 0) {
          // context.commit('setRecommandItem', response.data)
        } else {
          alert('검색 값이 존재하지 않습니다.')
        }
      })
      .catch((error) => {
        alert(error.response.data.message)
      })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/common.js